 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"ai-forge":"ai-forge","avv":"avv","calendar":"calendar","onboarding":"onboarding","landingpage~landingpages":"landingpage~landingpages","landingpage":"landingpage","leads":"leads","landingpages":"landingpages","registration":"registration","company":"company","createCompany":"createCompany","help-center":"help-center","inactive":"inactive","legal":"legal","licenseAgreement":"licenseAgreement","partner":"partner","performance":"performance","privacy":"privacy","settings":"settings","signup":"signup","valuation":"valuation","vue-apexcharts":"vue-apexcharts","import":"import","jschardet":"jschardet","libphonenumber-js/max":"libphonenumber-js/max","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"ai-forge":"ea6e2dcf","avv":"0fbe59c1","calendar":"e6085536","chunk-3d7318dd":"d8cf9799","chunk-3bbd27bc":"5814b4df","chunk-6d37fc69":"ba069568","chunk-08602244":"a21f3c2d","chunk-31cf0a72":"ebbf5859","chunk-8d37325a":"3f8e0888","onboarding":"e89f35b7","landingpage~landingpages":"7e4ec573","landingpage":"e31fbbc9","chunk-f2105b0c":"011c9bde","chunk-68bc354c":"76efc010","leads":"19bb07fe","landingpages":"cbc532df","registration":"1b4d593d","chunk-d098ff26":"83412a91","company":"5f0d3e38","createCompany":"e8b4d377","help-center":"e92f8856","inactive":"7f8aad64","legal":"05c054f0","licenseAgreement":"06dc7af0","partner":"03be1f29","performance":"601603f9","privacy":"9aa6fb1f","settings":"1ab92513","signup":"24db37a8","valuation":"810549bd","vue-apexcharts":"435330ad","chunk-2d0aa7a8":"e59240e7","chunk-2d0d01be":"2e65c025","chunk-1e3b161e":"8f2082f8","chunk-2d0b309a":"9ae93bb4","chunk-cc5d0fb6":"5e9b7e52","chunk-1565d8ec":"17a9ec40","chunk-872916f2":"bbdd21d4","chunk-4bf8567b":"92ae8953","chunk-31333532":"bc21b6bd","chunk-048753e8":"18488786","chunk-17108ddc":"0f216102","chunk-1eb3c719":"b3f94c3e","chunk-20688326":"84fd1f36","import":"38b22262","chunk-450cc3ee":"4b707582","jschardet":"65cfa7ac","libphonenumber-js/max":"491a11a1","xlsx":"c517dbc5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"avv":1,"calendar":1,"chunk-3bbd27bc":1,"chunk-08602244":1,"chunk-31cf0a72":1,"chunk-8d37325a":1,"onboarding":1,"landingpage~landingpages":1,"chunk-68bc354c":1,"leads":1,"landingpages":1,"registration":1,"chunk-d098ff26":1,"createCompany":1,"legal":1,"licenseAgreement":1,"partner":1,"performance":1,"signup":1,"chunk-1e3b161e":1,"chunk-cc5d0fb6":1,"chunk-872916f2":1,"chunk-4bf8567b":1,"chunk-31333532":1,"chunk-048753e8":1,"chunk-17108ddc":1,"chunk-1eb3c719":1,"chunk-20688326":1,"import":1,"chunk-450cc3ee":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"ai-forge":"ai-forge","avv":"avv","calendar":"calendar","onboarding":"onboarding","landingpage~landingpages":"landingpage~landingpages","landingpage":"landingpage","leads":"leads","landingpages":"landingpages","registration":"registration","company":"company","createCompany":"createCompany","help-center":"help-center","inactive":"inactive","legal":"legal","licenseAgreement":"licenseAgreement","partner":"partner","performance":"performance","privacy":"privacy","settings":"settings","signup":"signup","valuation":"valuation","vue-apexcharts":"vue-apexcharts","import":"import","jschardet":"jschardet","libphonenumber-js/max":"libphonenumber-js/max","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"ai-forge":"31d6cfe0","avv":"d5d5dcab","calendar":"b952dfa6","chunk-3d7318dd":"31d6cfe0","chunk-3bbd27bc":"7666357c","chunk-6d37fc69":"31d6cfe0","chunk-08602244":"90b0ed14","chunk-31cf0a72":"1547c0c6","chunk-8d37325a":"1d23e71a","onboarding":"50fb490c","landingpage~landingpages":"13275eb0","landingpage":"31d6cfe0","chunk-f2105b0c":"31d6cfe0","chunk-68bc354c":"fca02344","leads":"5c00d5db","landingpages":"32841565","registration":"5c8bbff7","chunk-d098ff26":"b04a32f9","company":"31d6cfe0","createCompany":"706d8b52","help-center":"31d6cfe0","inactive":"31d6cfe0","legal":"f9b50bc6","licenseAgreement":"04fb4012","partner":"00054ced","performance":"91c5ec70","privacy":"31d6cfe0","settings":"31d6cfe0","signup":"e6174705","valuation":"31d6cfe0","vue-apexcharts":"31d6cfe0","chunk-2d0aa7a8":"31d6cfe0","chunk-2d0d01be":"31d6cfe0","chunk-1e3b161e":"8afa3267","chunk-2d0b309a":"31d6cfe0","chunk-cc5d0fb6":"a2ab99d0","chunk-1565d8ec":"31d6cfe0","chunk-872916f2":"c16d9b1c","chunk-4bf8567b":"62107f56","chunk-31333532":"6ce7a114","chunk-048753e8":"316b3e44","chunk-17108ddc":"41a315df","chunk-1eb3c719":"f77acba3","chunk-20688326":"d9442f39","import":"f42e0554","chunk-450cc3ee":"d9442f39","jschardet":"31d6cfe0","libphonenumber-js/max":"31d6cfe0","xlsx":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["chunk-6d37fc69","chunk-f2105b0c","landingpage~landingpages","landingpages","chunk-68bc354c","leads","chunk-3d7318dd","landingpage","ai-forge","calendar","company","help-center","legal","performance","settings","valuation"]]);
 	return startupResult;
